import { toSlug } from "./slug";

/**
 * The slug always comes from the Romanian title (base_title), so a news item keeps
 * one URL in every language - the same one the server treats as canonical.
 */
export function toNewsSlug(news) {
    return `${toSlug(news?.base_title ?? news?.title, "noutate")}_${news?.id || ""}`;
}

export function formatNewsDate(value, language = "rom") {
    if (!value) return "";

    const date = new Date(String(value).replace(" ", "T"));

    if (Number.isNaN(date.getTime())) {
        return "";
    }

    const localeByLanguage = {
        rom: "ro-MD",
        rus: "ru-MD",
        eng: "en-US",
    };

    return new Intl.DateTimeFormat(localeByLanguage[language] || "ro-MD", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    }).format(date);
}

export function toDateTimeLocalValue(value) {
    if (!value) {
        return "";
    }

    return String(value).replace(" ", "T").slice(0, 16);
}

export function fromDateTimeLocalValue(value) {
    if (!value) {
        return "";
    }

    return String(value).replace("T", " ");
}
